import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as ko from "knockout";
import {Application} from "../application";

export class ShowEstimateUnitCostsCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.ShowEstimateUnitCosts;

    canExecute = ko.computed(() => {
        return !!this.app.state.estimate();
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(): JQueryPromise<any> {
        let dfd = $.Deferred();

        if (!this.canExecute())
            return dfd.reject().promise();

        this.app.state.estimateGridShowUnitCosts(!this.app.state.estimateGridShowUnitCosts());
        
        return dfd.resolve().promise();
    }
    
    name = "Show Estimate Unit Costs"
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/showEstimateUnitCosts.ts